// Translations
import landing from '../views/landing/translations/ru'

// Translation: Register (Russian)
export default Object.freeze({
	name: '',
	views: { landing }
})
